import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from '../hooks/useRefreshToken';
import useAuth from '../hooks/useAuth';

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth, persist } = useAuth();

    useEffect(() => {
        let isMounted = true;

        const verifyRefreshToken = async () => {
            try {
                await refresh();
            }
            catch (err) {
                console.error(err);
            }
            finally {
                isMounted && setIsLoading(false);
            }
        }

        verifyRefreshToken();

        return () => isMounted = false;
    }, [])

    useEffect(() => {
        /* console.log(`isLoading: ${isLoading}`)
        console.log(`aT: ${JSON.stringify(auth?.accessToken)}`) */
    }, [isLoading])

    return (
        <div className="content">
            {!persist
                ? <Outlet />
                : isLoading
                    ? <p className="loader"></p>
                : <Outlet />
            }
        </div>
    )
}

export default PersistLogin